import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Header from "../../components/Header";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config";

const ManageBranch = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const branch = location.state?.branch || {};
  const navigate = useNavigate();

  const handleFormSubmit = async (values, {resetForm}) => {
    console.log(values);
    try {
      let response;
      if (values.branchId) {
        // Update existing subscription
        response = await axios.put(
          `${config.apiBaseUrl}/update_branch/${values.branchId}`,
          values,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${document.cookie
                .split("; ")
                .find((row) => row.startsWith("teba_auth_token="))
                ?.split("=")[1]}`,
            },
          }
        );
        toast.success("Branch updated successfully", {
          onClose: () => {
            navigate("/branch_list")
          }
        });
      } else {
        // Add new subscription
        response = await axios.post(
          `${config.apiBaseUrl}/add_branch`,
          values,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${document.cookie
                .split("; ")
                .find((row) => row.startsWith("teba_auth_token="))
                ?.split("=")[1]}`,
            },
          }
        );
        toast.success("Branch added successfully");
        resetForm();
      }
      console.log(response.data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to save branch");
    }
  };

  const initialValues = {
    branchId: branch.branch_id || "",
    branchName: branch.branch_name || "",
    branchCode: branch.branch_code || "",
  };

  return (
    <Box m={{ xs: "12px", sm: "16px", md: "20px" }}>
      <Header title="ADD | MODIFY Branch" subtitle="Create or Modify a Branch" />
      <ToastContainer />
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          setFieldValue,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap={{ xs: "14px", sm: "18px", md: "24px" }}
              gridTemplateColumns={{ xs: "repeat(1, minmax(0, 1fr))", sm: "repeat(2, minmax(0, 1fr))", lg: "repeat(4, minmax(0, 1fr))" }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Branch Name"
                onBlur={handleBlur}
                onChange={(e) => setFieldValue("branchName", e.target.value)}
                value={values.branchName}
                name="branchName"
                error={!!touched.branchName && !!errors.branchName}
                helperText={touched.branchName && errors.branchName}
                sx={{ gridColumn: { xs: "span 1", sm: "span 2", lg: "span 2" } }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Branch Code"
                onBlur={handleBlur}
                onChange={(e) => setFieldValue("branchCode", e.target.value)}
                value={values.branchCode}
                name="branchCode"
                error={!!touched.branchCode && !!errors.branchCode}
                helperText={touched.branchCode && errors.branchCode}
                sx={{ gridColumn: { xs: "span 1", sm: "span 1", lg: "span 1" } }}
              />
            </Box>
            <Box display="flex" justifyContent="flex-start" flexWrap="wrap" gap={1} mt={{ xs: 3, sm: 4, md: 5 }}>
              <Button type="submit" color="secondary" variant="contained" size={isMobile ? "small" : "medium"}>
                Save
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  branchName: yup.string().required("required"),
  branchCode: yup.string().required("required"),
});



export default ManageBranch;